import { Fragment } from 'react';
import { Provider } from 'react-redux';

import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux/store';
import { VehicleService } from './views/VehicleService';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<VehicleService />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.VehicleService)
	.build();

export default Layout;
